module.exports = __webpack_public_path__ + "static/media/ranjana.8c0d2c11.jpg";